import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class StickyNavigation extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Bind event listeners for actions
    const menuBtn = this.querySelector('[data-action="menu"]');
    if (menuBtn) {
      menuBtn.addEventListener('click', this.openMenu.bind(this));
    }

    const cartBtn = this.querySelector('[data-action="cart"]');
    if (cartBtn) {
      cartBtn.addEventListener('click', this.openCart.bind(this));
    }

    const searchBtn = this.querySelector('[data-action="search"]');
    if (searchBtn) {
      searchBtn.addEventListener('click', this.openSearch.bind(this));
    }

    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    this.updateCartCountFromSession();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  onCartUpdate = (event) => {
    const itemCount = event.detail.data?.itemCount ?? 0;
    this.updateCartBadge(itemCount);
  };

  updateCartCountFromSession() {
    const stored = sessionStorage.getItem('cart-count');
    if (stored) {
      try {
        const { value } = JSON.parse(stored);
        const count = parseInt(value, 10);
        if (count >= 0) {
          this.updateCartBadge(count);
        }
      } catch (_) {}
    }
  }

  updateCartBadge(count) {
    const badge = this.querySelector('.sticky-navigation__cart-badge');
    if (badge) {
      badge.textContent = count;
      if (count === 0) {
        badge.style.display = 'none';
      } else {
        badge.style.display = 'flex';
      }
    }
  }

  openMenu(event) {
    event.preventDefault();
    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer) {
      if (typeof headerDrawer.open === 'function') {
        headerDrawer.open();
      } else {
        const summary = headerDrawer.querySelector('details summary');
        if (summary) {
          summary.click();
        }
      }
    } else {
      console.warn('header-drawer not found in document');
    }
  }

  openCart(event) {
    event.preventDefault();
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
      } else {
        const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) {
          trigger.click();
        } else {
          const cartIcon = document.querySelector('cart-icon');
          cartIcon?.click();
        }
      }
    } else {
      window.location.href = '/cart';
    }
  }

  openSearch(event) {
    event.preventDefault();
    const searchModal = document.getElementById('search-modal');
    if (searchModal) {
      if (typeof searchModal.showDialog === 'function') {
        searchModal.showDialog();
      } else {
        const dialog = searchModal.querySelector('dialog');
        dialog?.showModal();
      }
    } else {
      window.location.href = '/search';
    }
  }
}

if (!customElements.get('sticky-navigation-component')) {
  customElements.define('sticky-navigation-component', StickyNavigation);
}
